import * as React from 'react'

import SnapshotDataTable from './snapshotDataTable'
import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility';

const RankingModal = ({ label, closeModal, headers, data, }) => {
  const { modalRef } = useModalAccessibility(closeModal);
  return (
    <div className="modal-container ranking-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="rankingModalTitle"
        aria-modal="true"
        className="ranking-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <h2 id="rankingModalTitle">{label}</h2>
        <SnapshotDataTable
          data={data}
          headers={headers}
          numberOfRows={10}
        />
        <div className="button-section">
          <button className="quill-button medium outlined grey focus-on-light" onClick={closeModal} type="button">Close</button>
        </div>
      </div>
    </div>
  )
}

export default RankingModal
